module.exports = __webpack_public_path__ + "img/img2.4bf5d98f.jpg";